import { render, staticRenderFns } from "./BsGridColumn.vue?vue&type=template&id=6307a02e&scoped=true&"
import script from "./BsGridColumn.vue?vue&type=script&lang=js&"
export * from "./BsGridColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6307a02e",
  null
  
)

export default component.exports